export interface ITracingSegment {

	addNewSubsegment(name: string): ITracingSegment;

	addError(error: Error): void;

	close(): void;

}
